export default [
  { text: 'salesOverview.table.webApp', default: true, defaultOnMobile: true, value: 'web_app' },
  { text: 'salesOverview.table.terminal', default: true, defaultOnMobile: true, value: 'terminal' },
  { text: 'salesOverview.table.terminalTakeaway', default: true, defaultOnMobile: true, value: 'terminal_takeaway' },
  { text: 'salesOverview.table.terminalInside', default: true, defaultOnMobile: true, value: 'terminal_inside' },
  { text: 'salesOverview.table.wolt', default: true, defaultOnMobile: true, value: 'wolt' },
  { text: 'salesOverview.table.uberEats', default: true, defaultOnMobile: true, value: 'uber_eats' },
  { text: 'salesOverview.table.jet', default: true, defaultOnMobile: true, value: 'jet' },
  { text: 'salesOverview.table.pickup', default: true, defaultOnMobile: true, value: 'pickup' },
  { text: 'salesOverview.table.delivery', default: true, defaultOnMobile: true, value: 'delivery' },
  { text: 'salesOverview.table.inside', default: true, defaultOnMobile: true, value: 'inside' },
  { text: 'salesOverview.table.foodspot', default: true, defaultOnMobile: true, value: 'foodspot' },
  { text: 'salesOverview.table.orderAtTable', default: true, defaultOnMobile: true, value: 'orderAtTable' },
  { text: 'salesOverview.table.total', default: true, defaultOnMobile: true, value: 'total' },
];
